<div class="ipm-sound-purchase-credit-body">
    <div class="ipm-close-icon" (click)="closeCouponPopup()">
            <i class="pi pi-times"></i>
    </div>
    <div class="ipm-img-wrapper">
         <img src="./assets/imgs/credit-pop-icon.png" alt="credit-pop-icon">
    </div>
    <div class="ipm-credit-content-section">
        <h4>Purchase this <q>{{currentSoundData?.currentBeat?.title}}</q> by Credits</h4>
        <div class="ipm-sub-heading">
           <p>This purchase will deduct <span class="text-color">{{currentSoundData?.currentBeat?.creditPrice}} credits</span> from your available balance. </p>        
           <p>Available Credits: <span class="text-color">{{currentSoundData?.availableCredits}} credits</span></p>        
        </div>

        <div class="ipm-credit-btn-section">
            <button class="btn credit-btn" (click)="purchaseSound()">
                 <img src="assets/imgs/Lightning.svg" alt="lightning">
                Buy for {{currentSoundData?.currentBeat?.creditPrice}} Credits
            </button>
            <button class="btn price-btn" (click)="addToCart()">
               Buy for  <span>{{currentSoundData?.currentBeat?.price?.final_price === 0 ? 'Free' : (currentSoundData?.currentBeat?.price?.final_price | currency:'INR':'symbol':'1.0-0')}}</span>
            </button>
        </div>
    </div>
</div>


<ng-template #couponAvailablePopup let-data>
    <div class="ipm-applied-coupon-section" [class.ipm-diwali-coupon-popup]="isDiwaliSale">
        <div class="ipm-heading-model-section">
            <div class="ipm-close-icon" (click)="closeCouponPopup()">
                <i class="pi pi-times"></i>
            </div>
        </div>
        <div class="ipm-applied-coupon-body">
            <img *ngIf="isDiwaliSale" class="ipm-diwali-coupon-diya" src="assets/imgs/bpm-diwali-hour-sale/diya.png" alt="Diwali diya">
            <div *ngIf="isDiwaliSale" class="ipm-diwali-coupon-label">Diwali Special</div>
            <div class="coupon-applied-text">
                <span *ngIf="data?.coupon?.discount?.quantifier === 'percentage'">{{(data?.coupon?.discount?.value / 100) | percent}}</span>
                <span *ngIf="data?.coupon?.discount?.quantifier !== 'percentage'">{{data?.coupon?.discount?.value | currency : 'INR' : 'symbol' : '0.0-0'}}</span> OFF Coupon Applied!
            </div>
            <div class="ipm-discount-amount">
                Redeem {{(data?.coupon?.discount?.value * currentSoundData?.currentLic?.priceDetails?.final_price )/100|currency:'INR':'symbol':'0.0-0' }} Discount
            </div>
        </div>
    </div>
    <div class="ipm-coupon-checkout-section" [class.ipm-diwali-coupon-checkout-section]="isDiwaliSale">
        <button class="btn ipm-coupon-checkout-btn" (click)="goToCartWithCoupon()">
            Checkout
        </button>
    </div>
</ng-template>
